















































































































































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { Utils } from "@/core/Utils";
import Usuario from "@/models/usuarios/usuario.model";
import GenericAdd from "@/core/Generics/GenericAdd";

@Component({
  name: "create-account-beneficiario",
  components: {}
})
export default class CreateAccountBeneficario extends GenericAdd<Usuario> {
  cedulaMessage: string = "";

  constructor() {
    super();
    this.controller = "Usuario/CreateAccountUserOnline";
    this.model = new Usuario();
  }

  get isLoggedIn() {
    return this.$store.getters.isLoggedIn;
  }
  get isMobile() {
    return this.$store.state.isMobile;
  }

  created() {
    if (this.isLoggedIn) {
      this.$router.push("/");
    }
  }

  get isCedula() {
    return this.model.cedulaMask
      ? Utils.isCedula(this.model.cedulaMask)
      : false;
  }

  @Watch("model.cedulaMask")
  onCedulaBlur() {
    this.cedulaMessage = this.isCedula ? "" : "Cédula incorrecta";
  }

  createAccount() {
    this.model.cedula = this.model.cedulaMask ? this.model.cedulaMask.replace(/-/g, "") : "";
    this.model.noTarjeta = this.model.noTarjeta ? this.model.noTarjeta.replace(/ /g, "") : "";
    this.validate();
  }
  protected async add() {
    try {
      this.saving = true;
      let result = await this.repository.create(this.model);
      this.$emit("add", result);
      this.login();
    } catch (errors) {
      this.operationFailedErrors(errors);
      this.saving = false;
    } 
  }

  login() {
    let username = this.model.cedula;
    let password = this.model.password;
    this.saving = true;
    this.$store
      .dispatch("login", { username, password })
      .then(() => {
        this.$router.push("/");
        this.clean();
        this.operationSuccess();
      })
      .catch(err => {})
      .finally(() => {
        this.saving = false;
      });
  }
}
